import {
  GROUP_PERMISSIONS_LIST,
  GROUP_PERMISSIONS_LIST_SUCCESS,
  GROUP_PERMISSIONS_LIST_ERROR,
  GROUP_PERMISSIONS_NEW,
  GROUP_PERMISSIONS_NEW_SUCCESS,
  GROUP_PERMISSIONS_NEW_ERROR,
  GROUP_PERMISSIONS_EDIT,
  GROUP_PERMISSIONS_DELETE,
  GROUP_PERMISSIONS_DELETE_SUCCESS,
  GROUP_PERMISSIONS_DELETE_ERROR,
  GROUP_PERMISSIONS_TYPES_LIST,
  GROUP_PERMISSIONS_TYPES_LIST_SUCCESS,
  GROUP_PERMISSIONS_TYPES_LIST_ERROR,
} from "./actionTypes"


export const groupPermissionsList = data => ({
  type: GROUP_PERMISSIONS_LIST,
  payload: data
});

export const groupPermissionsListSuccess = data => ({
  type: GROUP_PERMISSIONS_LIST_SUCCESS,
  payload: {data}
});

export const groupPermissionsListError = error => ({
  type: GROUP_PERMISSIONS_LIST_ERROR,
  payload: error
});

export const groupPermissionsNew = data => ({
  type: GROUP_PERMISSIONS_NEW,
  payload: data
});

export const groupPermissionsNewSuccess = data => ({
  type: GROUP_PERMISSIONS_NEW_SUCCESS,
  payload: {data}
});

export const groupPermissionsNewError = error => ({
  type: GROUP_PERMISSIONS_NEW_ERROR,
  payload: error
});

export const groupPermissionsEdit = data => ({
  type: GROUP_PERMISSIONS_EDIT,
  payload: data
});

export const groupPermissionsDelete = data => ({
  type: GROUP_PERMISSIONS_DELETE,
  payload: data
});

export const groupPermissionsDeleteSuccess = data => ({
  type: GROUP_PERMISSIONS_DELETE_SUCCESS,
  payload: {data}
});

export const groupPermissionsDeleteError = error => ({
  type: GROUP_PERMISSIONS_DELETE_ERROR,
  payload: error
});

export const groupPermissionsTypesList = data => ({
  type: GROUP_PERMISSIONS_TYPES_LIST,
  payload: data
});

export const groupPermissionsTypesListSuccess = data => ({
  type: GROUP_PERMISSIONS_TYPES_LIST_SUCCESS,
  payload: {data}
});

export const groupPermissionsTypesListError = error => ({
  type: GROUP_PERMISSIONS_TYPES_LIST_ERROR,
  payload: error
});